<template>
    <ProductCard
        product-type="parking"
        :product-location-type="locationType"
        :product-image="optimizedImage"
        :product-link="productUrl"
        :product-name="productData.name"
        :product-rating="Number(productData.ratings.rating)"
        :product-rating-count="productData.ratings.comment_count"
        :product-distance="productData.distance"
        :airport-code="(route.params.IATA as string).toUpperCase()"
        :product-shuttle-option="productData.shuttle_option"
        :product-options="productData.options"
        :product-stars-rating="Number(productData.ratings.rating)"
        card-type="ParkingLotProductCard"
    />
</template>

<script lang="ts" setup>
import ProductCard from '../cards/ProductCard.vue';
import type { IParkingProduct } from '@nuxt-monorepo/ui/types';

const props = defineProps<{
    productData: IParkingProduct;
}>();

const route = useRoute();
const locationType = computed(() => {
    return route.path.includes('port-parking') ? 'port' : 'airport';
});

const img = useImage();

const optimizedImage = computed(() => {
    const imgUrl = img(props.productData?.media?.logo, { format: 'webp', height: 100 });
    return imgUrl;
});

const productUrl = computed(() => {
    return props.productData?.content?.psf_url
        ? props.productData.content.psf_url
        : '/' + props.productData?.content?.slug;
});
</script>

<style lang="postcss" scoped></style>
